import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Flex} from '@tempo/core';
import {useTranslation} from '@app/hooks/use-translation';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const FeatureMusic: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['hifi']});
	return (
		<LandingIllustrationSection
			imageContained
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('deezerhifilandingpage_title_hearabbeyroadasmeanttobeheard_web')}
					</LandingHeading>
					<LandingParagraph fontFamily="Deezer" fontSize="2xl">
						{t('deezerhifilandingpage_text_ringostarquote_web')}
					</LandingParagraph>
					<LandingParagraph color="text.neutral.primary.default">
						{t('deezerhifilandingpage_title_ringostarrbilboardmagazine_web')}
					</LandingParagraph>
				</>
			}
			image={
				<Flex justifyContent="center" alignItems="center" width="100%">
					<Image
						borderRadius="10px"
						maxWidth="230px"
						alt=""
						src="dacf9bb635faf80ca73c978121d6f68c.jpg"
						aspectRatio="460/460"
					/>
				</Flex>
			}
		/>
	);
};
